module.exports = __webpack_public_path__ + "img/img_left_nav_bonus_hover.4ecb4208.svg";